<template>
  <div class="wrapper">
    <div
      class="circle"
      :class="{ active: selected }"
      :style="style"
      @click="toggle()"
    >
      <i class="mainIcon" :class="icon"></i>
      <i v-if="selected" class="selected fas fa-check"></i>
    </div>
    <div class="text">{{ type }}</div>
  </div>
</template>
<style scoped>
div.circle {
  width: 40px;
  height: 40px;
  display: inline-block;
  border: 1px solid #a8a8a8;
  border-radius: 60px;
  padding: 5px;
  /* padding-right: 90px; */
  line-height: 12px;
  margin: 10px;
  margin-right: 5px;
  margin-left: 2px;
  margin-bottom: 2px;
  position: relative;
  text-align: center;
  opacity: 0.4;
  transition: 0.35s all ease;
  filter: grayscale(70%);
  cursor: pointer;
}
div.circle:hover{
  scale: 1.17;
}
div.circle.active {
  opacity: 1 !important;
  filter: grayscale(0%);
}
div.circle i {
  font-size: 20px;
}
.mainIcon {
  font-size: 44px;
  padding-top: 15px;
}
.selected {
  color: white;
  font-size: 12px !important;
  padding: 3px;
  position: absolute;
  right: 0px;
  top: 0px;
  background: #5bc327;
  border-radius: 20px;
}
.text {
  font-size: 8px;
  font-weight: bold;
  text-align: center;
}
.wrapper {
  display: inline-block;
}
</style>
<script>
export default {
  name: "circleButton",
  data() {
    return {
      active: false,
      style: {
        background: this.background,
        color: this.color,
      },
    };
  },
  props: {
    icon: String,
    selected: Boolean,
    type: String,
    color: String,
    background: String,
  },
  methods: {
    toggle() {
      this.$emit("toggle", this.type);
    },
  },
};
</script>
